import { render } from "./Reasignacion.vue?vue&type=template&id=66e94c54"
import script from "./Reasignacion.vue?vue&type=script&lang=js"
export * from "./Reasignacion.vue?vue&type=script&lang=js"

import "./Reasignacion.vue?vue&type=style&index=0&id=66e94c54&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__